import { render, staticRenderFns } from "./PartnerCertificate.vue?vue&type=template&id=3946e0e4&scoped=true&"
import script from "./PartnerCertificate.vue?vue&type=script&lang=ts&"
export * from "./PartnerCertificate.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerCertificate.vue?vue&type=style&index=0&id=3946e0e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946e0e4",
  null
  
)

export default component.exports